import { Environment } from './environment.interface';

export const environment: Environment = {
  development: false,
  production: true,
  staging: true,
  apiUrl: 'https://api.staging.upbycellance.com:443/api'
};
